// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=js"
// @generated from file console/common/v1/common.proto (package console.common.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file console/common/v1/common.proto.
 */
export const file_console_common_v1_common: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * What a tablet says about its own boot and build, read from system
 * properties, global settings and the file system. Self-reported: a rooted
 * tablet can hide every part of it, so the console records it for MotionSafe
 * staff and refuses nothing on it. The tablet sends what it read; the console
 * decides what it means. An empty string is a property the tablet could not
 * read (unset, or closed to apps by SELinux).
 *
 * @generated from message console.common.v1.DeviceIntegrity
 */
export type DeviceIntegrity = Message<"console.common.v1.DeviceIntegrity"> & {
  /**
   * `ro.boot.verifiedbootstate`: green, yellow, orange or red.
   *
   * @generated from field: string verified_boot_state = 1;
   */
  verifiedBootState: string;

  /**
   * `ro.boot.vbmeta.device_state`: locked or unlocked.
   *
   * @generated from field: string vbmeta_device_state = 2;
   */
  vbmetaDeviceState: string;

  /**
   * `ro.boot.flash.locked`: 1 locked, 0 unlocked.
   *
   * @generated from field: string flash_locked = 3;
   */
  flashLocked: string;

  /**
   * `ro.build.type`: user, userdebug or eng.
   *
   * @generated from field: string build_type = 4;
   */
  buildType: string;

  /**
   * `ro.build.tags`, e.g. release-keys or test-keys.
   *
   * @generated from field: string build_tags = 5;
   */
  buildTags: string;

  /**
   * `ro.debuggable`: 1 when any app on the tablet may be debugged.
   *
   * @generated from field: string debuggable = 6;
   */
  debuggable: string;

  /**
   * Paths where an su binary or a root manager's files were found. Empty
   * when none was.
   *
   * @generated from field: repeated string root_traces = 7;
   */
  rootTraces: string[];

  /**
   * Settings.Global: developer options, USB debugging, wireless debugging.
   *
   * @generated from field: bool developer_options = 8;
   */
  developerOptions: boolean;

  /**
   * @generated from field: bool usb_debugging = 9;
   */
  usbDebugging: boolean;

  /**
   * @generated from field: bool wireless_debugging = 10;
   */
  wirelessDebugging: boolean;
};

/**
 * Describes the message console.common.v1.DeviceIntegrity.
 * Use `create(DeviceIntegritySchema)` to create a new message.
 */
export const DeviceIntegritySchema: GenMessage<DeviceIntegrity> = /*@__PURE__*/
  messageDesc(file_console_common_v1_common, 0);

/**
 * The identity of an external storage key: what an administrator compares
 * between a tablet and the console. Never the material. Mirrors the fields the
 * app's `ExternalKeyStatus` exposes.
 *
 * @generated from message console.common.v1.KeyIdentity
 */
export type KeyIdentity = Message<"console.common.v1.KeyIdentity"> & {
  /**
   * Rotation label, `[a-z0-9]{1,16}`.
   *
   * @generated from field: string generation = 1;
   */
  generation: string;

  /**
   * Organization slug, `[a-z0-9-]{1,32}`; the same value as the org's slug.
   *
   * @generated from field: string org_id = 2;
   */
  orgId: string;

  /**
   * Eight hex characters naming this exact key.
   *
   * @generated from field: string fingerprint = 3;
   */
  fingerprint: string;

  /**
   * @generated from field: console.common.v1.KeyState state = 4;
   */
  state: KeyState;
};

/**
 * Describes the message console.common.v1.KeyIdentity.
 * Use `create(KeyIdentitySchema)` to create a new message.
 */
export const KeyIdentitySchema: GenMessage<KeyIdentity> = /*@__PURE__*/
  messageDesc(file_console_common_v1_common, 1);

/**
 * Per-organization session and security policy. Read by the tablet through
 * the grant's claims; edited by org admins in the console (with two fields
 * reserved to MotionSafe staff).
 *
 * @generated from message console.common.v1.Policy
 */
export type Policy = Message<"console.common.v1.Policy"> & {
  /**
   * How long a device goes between proofs that its operator is still the one
   * holding it. A device online renews every 15 minutes, never past the
   * sign-in's limit. With PIN locking on, the app asks for the operator's PIN
   * at the end of it; with PIN locking off, the sign-in ends there.
   *
   * @generated from field: uint32 session_ttl_hours = 1;
   */
  sessionTtlHours: number;

  /**
   * The renewal grace period: how much longer a device that cannot reach
   * the console keeps working past its session's end.
   *
   * @generated from field: uint32 offline_grace_hours = 2;
   */
  offlineGraceHours: number;

  /**
   * @generated from field: bool require_mfa = 3;
   */
  requireMfa: boolean;

  /**
   * Set by MotionSafe staff for contracts that require MFA; hides the off
   * switch from the org admin.
   *
   * @generated from field: bool mfa_locked = 4;
   */
  mfaLocked: boolean;

  /**
   * @generated from field: repeated console.common.v1.MfaFactor allowed_factors = 5;
   */
  allowedFactors: MfaFactor[];

  /**
   * @generated from field: console.common.v1.OfflineResume offline_resume = 6;
   */
  offlineResume: OfflineResume;

  /**
   * How many operator sessions one tablet keeps for offline resume.
   *
   * @generated from field: uint32 max_cached_sessions = 7;
   */
  maxCachedSessions: number;

  /**
   * With PIN locking on: days a sign-in lasts before the password and 2FA
   * again, 1 to 30, never less than one session length. Default 7. Unused
   * with PIN locking off, when a sign-in lasts one session length.
   *
   * @generated from field: uint32 max_sign_in_days = 9;
   */
  maxSignInDays: number;

  /**
   * With PIN locking on: minutes without a touch before the app locks and
   * asks for the operator's PIN, 1 to the session length (at most 1440); 0
   * is off. Absent on a write: unchanged. Default 15.
   *
   * @generated from field: optional uint32 idle_lock_minutes = 10;
   */
  idleLockMinutes?: number | undefined;

  /**
   * Whether operators may share a collection decrypted, set by the
   * organization's administrators. In effect only while MotionSafe's
   * sharing override allows it (FEATURE_DECRYPTED_SHARING), whatever this
   * says. Default on. Absent on a write: unchanged.
   *
   * @generated from field: optional bool decrypted_sharing = 11;
   */
  decryptedSharing?: boolean | undefined;

  /**
   * Whether operators may send a collection over Wi-Fi Direct, and whether
   * the organization's devices may receive one. In effect only while
   * the FEATURE_WIFI_DIRECT_SHARING override allows it. Default on. Absent on a write: unchanged.
   *
   * @generated from field: optional bool wifi_direct_send = 12;
   */
  wifiDirectSend?: boolean | undefined;

  /**
   * @generated from field: optional bool wifi_direct_receive = 13;
   */
  wifiDirectReceive?: boolean | undefined;

  /**
   * Whether those transfers may go to, and come from, other organizations.
   * In effect only with FEATURE_CROSS_ORG_TRANSFER and Wi-Fi Direct in the
   * same direction. Default off. Absent on a write: unchanged.
   *
   * @generated from field: optional bool cross_org_send = 14;
   */
  crossOrgSend?: boolean | undefined;

  /**
   * @generated from field: optional bool cross_org_receive = 15;
   */
  crossOrgReceive?: boolean | undefined;
};

/**
 * Describes the message console.common.v1.Policy.
 * Use `create(PolicySchema)` to create a new message.
 */
export const PolicySchema: GenMessage<Policy> = /*@__PURE__*/
  messageDesc(file_console_common_v1_common, 2);

/**
 * A legal document's text as the device and the console draw it. The
 * console parses the Markdown an admin writes into these blocks (headings,
 * paragraphs, lists, and inline emphasis and links), so neither surface
 * carries a Markdown parser and both show the same thing. Anything else in
 * the Markdown is refused when it is saved.
 *
 * @generated from message console.common.v1.LegalBlock
 */
export type LegalBlock = Message<"console.common.v1.LegalBlock"> & {
  /**
   * @generated from oneof console.common.v1.LegalBlock.block
   */
  block: {
    /**
     * @generated from field: console.common.v1.LegalHeading heading = 1;
     */
    value: LegalHeading;
    case: "heading";
  } | {
    /**
     * @generated from field: console.common.v1.LegalParagraph paragraph = 2;
     */
    value: LegalParagraph;
    case: "paragraph";
  } | {
    /**
     * @generated from field: console.common.v1.LegalList list = 3;
     */
    value: LegalList;
    case: "list";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message console.common.v1.LegalBlock.
 * Use `create(LegalBlockSchema)` to create a new message.
 */
export const LegalBlockSchema: GenMessage<LegalBlock> = /*@__PURE__*/
  messageDesc(file_console_common_v1_common, 3);

/**
 * @generated from message console.common.v1.LegalHeading
 */
export type LegalHeading = Message<"console.common.v1.LegalHeading"> & {
  /**
   * 1 to 3.
   *
   * @generated from field: uint32 level = 1;
   */
  level: number;

  /**
   * @generated from field: repeated console.common.v1.LegalSpan spans = 2;
   */
  spans: LegalSpan[];
};

/**
 * Describes the message console.common.v1.LegalHeading.
 * Use `create(LegalHeadingSchema)` to create a new message.
 */
export const LegalHeadingSchema: GenMessage<LegalHeading> = /*@__PURE__*/
  messageDesc(file_console_common_v1_common, 4);

/**
 * @generated from message console.common.v1.LegalParagraph
 */
export type LegalParagraph = Message<"console.common.v1.LegalParagraph"> & {
  /**
   * @generated from field: repeated console.common.v1.LegalSpan spans = 1;
   */
  spans: LegalSpan[];
};

/**
 * Describes the message console.common.v1.LegalParagraph.
 * Use `create(LegalParagraphSchema)` to create a new message.
 */
export const LegalParagraphSchema: GenMessage<LegalParagraph> = /*@__PURE__*/
  messageDesc(file_console_common_v1_common, 5);

/**
 * @generated from message console.common.v1.LegalList
 */
export type LegalList = Message<"console.common.v1.LegalList"> & {
  /**
   * @generated from field: bool ordered = 1;
   */
  ordered: boolean;

  /**
   * @generated from field: repeated console.common.v1.LegalListItem items = 2;
   */
  items: LegalListItem[];
};

/**
 * Describes the message console.common.v1.LegalList.
 * Use `create(LegalListSchema)` to create a new message.
 */
export const LegalListSchema: GenMessage<LegalList> = /*@__PURE__*/
  messageDesc(file_console_common_v1_common, 6);

/**
 * @generated from message console.common.v1.LegalListItem
 */
export type LegalListItem = Message<"console.common.v1.LegalListItem"> & {
  /**
   * @generated from field: repeated console.common.v1.LegalSpan spans = 1;
   */
  spans: LegalSpan[];
};

/**
 * Describes the message console.common.v1.LegalListItem.
 * Use `create(LegalListItemSchema)` to create a new message.
 */
export const LegalListItemSchema: GenMessage<LegalListItem> = /*@__PURE__*/
  messageDesc(file_console_common_v1_common, 7);

/**
 * A run of text with one style. On the device a link is shown, not
 * followed: the tablets are kiosked.
 *
 * @generated from message console.common.v1.LegalSpan
 */
export type LegalSpan = Message<"console.common.v1.LegalSpan"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: bool strong = 2;
   */
  strong: boolean;

  /**
   * @generated from field: bool emphasis = 3;
   */
  emphasis: boolean;

  /**
   * An https or mailto address; empty when the span is not a link.
   *
   * @generated from field: string link = 4;
   */
  link: string;
};

/**
 * Describes the message console.common.v1.LegalSpan.
 * Use `create(LegalSpanSchema)` to create a new message.
 */
export const LegalSpanSchema: GenMessage<LegalSpan> = /*@__PURE__*/
  messageDesc(file_console_common_v1_common, 8);

/**
 * On what authority an operator acts. Decides whether a warrant and an
 * attestation are required before a collect.
 *
 * @generated from enum console.common.v1.OperatorRole
 */
export enum OperatorRole {
  /**
   * @generated from enum value: OPERATOR_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: OPERATOR_ROLE_UNRESTRICTED = 1;
   */
  UNRESTRICTED = 1,

  /**
   * @generated from enum value: OPERATOR_ROLE_LAW_ENFORCEMENT = 2;
   */
  LAW_ENFORCEMENT = 2,
}

/**
 * Describes the enum console.common.v1.OperatorRole.
 */
export const OperatorRoleSchema: GenEnum<OperatorRole> = /*@__PURE__*/
  enumDesc(file_console_common_v1_common, 0);

/**
 * What an organization has bought. Org-wide; every seated operator carries all
 * of them unless restricted (see admin.v1.User.restricted_products).
 *
 * @generated from enum console.common.v1.Product
 */
export enum Product {
  /**
   * @generated from enum value: PRODUCT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The collect wizard and everything derived from a collection.
   *
   * @generated from enum value: PRODUCT_INSIGHTS = 1;
   */
  INSIGHTS = 1,

  /**
   * The wipe (sanitize) wizard.
   *
   * @generated from enum value: PRODUCT_PRIVACY = 2;
   */
  PRIVACY = 2,
}

/**
 * Describes the enum console.common.v1.Product.
 */
export const ProductSchema: GenEnum<Product> = /*@__PURE__*/
  enumDesc(file_console_common_v1_common, 1);

/**
 * What MotionSafe staff set per organization: the paid add-ons (SSO,
 * DIRECTORY_SYNC) and the sharing overrides, which hold the organization's
 * own sharing settings in Policy and are not add-ons.
 *
 * @generated from enum console.common.v1.Feature
 */
export enum Feature {
  /**
   * @generated from enum value: FEATURE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FEATURE_SSO = 1;
   */
  SSO = 1,

  /**
   * Requires FEATURE_SSO.
   *
   * @generated from enum value: FEATURE_DIRECTORY_SYNC = 2;
   */
  DIRECTORY_SYNC = 2,

  /**
   * Sharing override: decrypted sharing allowed for the organization.
   * Allowed unless staff turn it off: an organization with no row is
   * allowed. Its administrators turn it off or on (Policy.decrypted_sharing);
   * it is in effect only with both. Row value `decrypted_sharing`.
   *
   * @generated from enum value: FEATURE_DECRYPTED_SHARING = 3;
   */
  DECRYPTED_SHARING = 3,

  /**
   * Sharing override: sending and receiving collections over Wi-Fi Direct.
   * Allowed unless staff turn it off: an organization with no row is
   * allowed. Its administrators then turn sending and receiving off or on
   * (Policy.wifi_direct_send, Policy.wifi_direct_receive). Row value
   * `wifi_direct_sharing`.
   *
   * @generated from enum value: FEATURE_WIFI_DIRECT_SHARING = 4;
   */
  WIFI_DIRECT_SHARING = 4,

  /**
   * Sharing override: Wi-Fi Direct transfers to and from other
   * organizations. Off until staff allow it; its administrators then turn sending and receiving on
   * (Policy.cross_org_send, Policy.cross_org_receive). Each also needs Wi-Fi
   * Direct in the same direction. Row value `cross_org_transfer`.
   *
   * @generated from enum value: FEATURE_CROSS_ORG_TRANSFER = 5;
   */
  CROSS_ORG_TRANSFER = 5,
}

/**
 * Describes the enum console.common.v1.Feature.
 */
export const FeatureSchema: GenEnum<Feature> = /*@__PURE__*/
  enumDesc(file_console_common_v1_common, 2);

/**
 * Where an organization's operators authenticate.
 *
 * @generated from enum console.common.v1.IdpMode
 */
export enum IdpMode {
  /**
   * @generated from enum value: IDP_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Email + password + MFA through the identity vendor. The default tier.
   *
   * @generated from enum value: IDP_MODE_MANAGED = 1;
   */
  MANAGED = 1,

  /**
   * The organization's own IdP (SAML/OIDC). Requires FEATURE_SSO.
   *
   * @generated from enum value: IDP_MODE_SSO = 2;
   */
  SSO = 2,
}

/**
 * Describes the enum console.common.v1.IdpMode.
 */
export const IdpModeSchema: GenEnum<IdpMode> = /*@__PURE__*/
  enumDesc(file_console_common_v1_common, 3);

/**
 * Lifecycle of an organization's external storage key.
 *
 * @generated from enum console.common.v1.KeyState
 */
export enum KeyState {
  /**
   * @generated from enum value: KEY_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * No longer issued: a key is current from its creation (2026-10-19). Kept
   * so the value is never reused.
   *
   * @generated from enum value: KEY_STATE_STAGED = 1;
   */
  STAGED = 1,

  /**
   * The key new collections seal under. Exactly one per organization.
   *
   * @generated from enum value: KEY_STATE_CURRENT = 2;
   */
  CURRENT = 2,

  /**
   * Replaced; kept forever and still delivered as archived so every card
   * sealed under it stays openable. There is no destroyed state.
   *
   * @generated from enum value: KEY_STATE_RETIRED = 3;
   */
  RETIRED = 3,
}

/**
 * Describes the enum console.common.v1.KeyState.
 */
export const KeyStateSchema: GenEnum<KeyState> = /*@__PURE__*/
  enumDesc(file_console_common_v1_common, 4);

/**
 * @generated from enum console.common.v1.ConsoleRole
 */
export enum ConsoleRole {
  /**
   * @generated from enum value: CONSOLE_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * MotionSafe staff; spans organizations.
   *
   * @generated from enum value: CONSOLE_ROLE_MS_SUPERADMIN = 1;
   */
  MS_SUPERADMIN = 1,

  /**
   * Administers exactly one organization. Does not consume a seat.
   *
   * @generated from enum value: CONSOLE_ROLE_ORG_ADMIN = 2;
   */
  ORG_ADMIN = 2,

  /**
   * Signs in on tablets. Consumes a seat while active.
   *
   * @generated from enum value: CONSOLE_ROLE_OPERATOR = 3;
   */
  OPERATOR = 3,

  /**
   * Retired: read-only staff are MS_STAFF holding no staff role. No account
   * has held it since the migration that made MS_STAFF (2026-10-05).
   *
   * @generated from enum value: CONSOLE_ROLE_MS_READONLY = 4 [deprecated = true];
   * @deprecated
   */
  MS_READONLY = 4,

  /**
   * MotionSafe staff who are not admins: they see every organization and
   * change what their staff roles allow (`StaffRole`), and nothing with none.
   *
   * @generated from enum value: CONSOLE_ROLE_MS_STAFF = 5;
   */
  MS_STAFF = 5,
}

/**
 * Describes the enum console.common.v1.ConsoleRole.
 */
export const ConsoleRoleSchema: GenEnum<ConsoleRole> = /*@__PURE__*/
  enumDesc(file_console_common_v1_common, 5);

/**
 * What a member of MotionSafe staff who is not an admin may change, beyond
 * seeing everything. A person holds any number; admins hold none, since they
 * may change anything. Which calls each role allows is the console's own
 * table, served by UserService.ListStaffRoles.
 *
 * @generated from enum console.common.v1.StaffRole
 */
export enum StaffRole {
  /**
   * @generated from enum value: STAFF_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Helps a customer's people: invitations, password and 2FA resets,
   * sessions, suspending, and checking people against the identity provider.
   *
   * @generated from enum value: STAFF_ROLE_SUPPORT = 1;
   */
  SUPPORT = 1,

  /**
   * Ships and receives tablets: assigns, moves, suspends, takes out of
   * circulation, and deletes devices.
   *
   * @generated from enum value: STAFF_ROLE_FULFILLMENT = 2;
   */
  FULFILLMENT = 2,

  /**
   * Sales and onboarding: creates and activates organizations, and sets
   * their seats, products, add-ons, and sharing overrides.
   *
   * @generated from enum value: STAFF_ROLE_ACCOUNTS = 3;
   */
  ACCOUNTS = 3,
}

/**
 * Describes the enum console.common.v1.StaffRole.
 */
export const StaffRoleSchema: GenEnum<StaffRole> = /*@__PURE__*/
  enumDesc(file_console_common_v1_common, 6);

/**
 * @generated from enum console.common.v1.UserStatus
 */
export enum UserStatus {
  /**
   * @generated from enum value: USER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_STATUS_INVITED = 1;
   */
  INVITED = 1,

  /**
   * Would be active but the organization's seat pool was full when the
   * account was created or synced. Refused at sign-in until a seat frees.
   *
   * @generated from enum value: USER_STATUS_PENDING_SEAT = 2;
   */
  PENDING_SEAT = 2,

  /**
   * @generated from enum value: USER_STATUS_ACTIVE = 3;
   */
  ACTIVE = 3,

  /**
   * @generated from enum value: USER_STATUS_SUSPENDED = 4;
   */
  SUSPENDED = 4,

  /**
   * Removed by directory sync or by an admin. Frees the seat.
   *
   * @generated from enum value: USER_STATUS_DEPROVISIONED = 5;
   */
  DEPROVISIONED = 5,
}

/**
 * Describes the enum console.common.v1.UserStatus.
 */
export const UserStatusSchema: GenEnum<UserStatus> = /*@__PURE__*/
  enumDesc(file_console_common_v1_common, 7);

/**
 * @generated from enum console.common.v1.OrgStatus
 */
export enum OrgStatus {
  /**
   * @generated from enum value: ORG_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORG_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: ORG_STATUS_SUSPENDED = 3;
   */
  SUSPENDED = 3,

  /**
   * @generated from enum value: ORG_STATUS_CLOSED = 4;
   */
  CLOSED = 4,
}

/**
 * Describes the enum console.common.v1.OrgStatus.
 */
export const OrgStatusSchema: GenEnum<OrgStatus> = /*@__PURE__*/
  enumDesc(file_console_common_v1_common, 8);

/**
 * Whether MotionSafe staff have assigned the device: looked at what
 * registered, matched its hardware id to a tablet they know, and given it
 * to an organization. The fleet cannot vouch for itself by its hardware, so
 * this is a person's word, recorded with their name. A device not assigned
 * can do nothing: nobody signs in on it and it is given no keyring.
 *
 * @generated from enum console.common.v1.DeviceAssignment
 */
export enum DeviceAssignment {
  /**
   * @generated from enum value: DEVICE_ASSIGNMENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEVICE_ASSIGNMENT_ASSIGNED = 1;
   */
  ASSIGNED = 1,

  /**
   * @generated from enum value: DEVICE_ASSIGNMENT_NOT_ASSIGNED = 2;
   */
  NOT_ASSIGNED = 2,
}

/**
 * Describes the enum console.common.v1.DeviceAssignment.
 */
export const DeviceAssignmentSchema: GenEnum<DeviceAssignment> = /*@__PURE__*/
  enumDesc(file_console_common_v1_common, 9);

/**
 * Whether a registered tablet may be used. Checked before sign-in through the
 * open CheckDevice call and enforced again on every authenticated device call.
 *
 * @generated from enum console.common.v1.DeviceStatus
 */
export enum DeviceStatus {
  /**
   * @generated from enum value: DEVICE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEVICE_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * Blocked by an administrator or staff; reversible.
   *
   * @generated from enum value: DEVICE_STATUS_SUSPENDED = 2;
   */
  SUSPENDED = 2,

  /**
   * Hardware or app version the fleet no longer supports; set by staff or by
   * the support policy. Reversible once the tablet is updated or the policy
   * changes.
   *
   * @generated from enum value: DEVICE_STATUS_UNSUPPORTED = 3;
   */
  UNSUPPORTED = 3,

  /**
   * Lost, retired, or replaced; permanent. The key cannot register again.
   *
   * @generated from enum value: DEVICE_STATUS_REVOKED = 4;
   */
  REVOKED = 4,

  /**
   * Taken out of use by MotionSafe staff and belonging to no organization:
   * in a cupboard, in repair, waiting for its next customer. Nobody signs in
   * on it, and it clears everything it holds at its next contact. Staff put
   * it back by giving it to an organization.
   *
   * @generated from enum value: DEVICE_STATUS_OUT_OF_CIRCULATION = 5;
   */
  OUT_OF_CIRCULATION = 5,
}

/**
 * Describes the enum console.common.v1.DeviceStatus.
 */
export const DeviceStatusSchema: GenEnum<DeviceStatus> = /*@__PURE__*/
  enumDesc(file_console_common_v1_common, 10);

/**
 * Second factors an organization allows for managed accounts: an
 * authenticator app. Text messages were dropped because the vendor sends
 * them to US numbers only.
 *
 * @generated from enum console.common.v1.MfaFactor
 */
export enum MfaFactor {
  /**
   * @generated from enum value: MFA_FACTOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MFA_FACTOR_TOTP = 1;
   */
  TOTP = 1,
}

/**
 * Describes the enum console.common.v1.MfaFactor.
 */
export const MfaFactorSchema: GenEnum<MfaFactor> = /*@__PURE__*/
  enumDesc(file_console_common_v1_common, 11);

/**
 * Whether an operator who signed in on a tablet earlier may resume that
 * session offline with a PIN.
 *
 * @generated from enum console.common.v1.OfflineResume
 */
export enum OfflineResume {
  /**
   * @generated from enum value: OFFLINE_RESUME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: OFFLINE_RESUME_PIN = 1;
   */
  PIN = 1,

  /**
   * @generated from enum value: OFFLINE_RESUME_DISABLED = 2;
   */
  DISABLED = 2,
}

/**
 * Describes the enum console.common.v1.OfflineResume.
 */
export const OfflineResumeSchema: GenEnum<OfflineResume> = /*@__PURE__*/
  enumDesc(file_console_common_v1_common, 12);

